import defaultConfig from './config';
import { persistStore } from 'redux-persist';

export default function persistWeb(store, config = defaultConfig) {
  return new Promise(resolve => {
    persistStore(store, config, resolve);
  });
}
